import { isStagnationOrOfflineSingleAlert } from "@/common/utils.ts";
import { eventPeriode, isGoodSampling } from "@/common/date.ts";

export const prepareVariableParameters = (
  alert: any,
  start: string,
  end: string,
  alertVariables: any[],
): object[] => {
  // For stagnation and offline_single alerts, load all variables
  // else , only load the first variable
  const isStagnationOrOfflineSingle = isStagnationOrOfflineSingleAlert(alert);
  const variablesToLoad = isStagnationOrOfflineSingle
    ? alertVariables
    : [alertVariables[0]];
  const period = eventPeriode([start, end]);
  const variableParameters = [];

  for (const variable of variablesToLoad) {
    const goodSampling: boolean = isGoodSampling(
      variable.sampling,
      variable.samplingUnit,
      period,
    );
    const sampling = goodSampling ? variable.sampling : undefined;
    const samplingUnit = goodSampling ? variable.samplingUnit : undefined;
    variableParameters.push({
      period,
      variable: {
        ...variable.variable,
        sampling,
        samplingUnit,
        aggregation: variable.aggregation,
      },
    });
  }
  return variableParameters;
};
